import { Transfer } from "ant-design-vue";
import "./src/tranfer.less"
const { ...other } = Transfer;
const YwTransfer = {
	...other,
	name: "YwTransfer",
};

YwTransfer.install = function (Vue) {
	Vue.component(YwTransfer.name, Transfer);
};

export default YwTransfer;
